export default __webpack_public_path__ + "static/media/home.f19f0176.webp";